import { Component, OnInit, Output, EventEmitter, Input} from '@angular/core';

@Component({
	selector: 'app-loading',
	template: `
		<!-- loading -->
	      <div class="row">
	        <div class="col-md-12">
	          <div class="text-center">
	            <br><br>
	            Cargando...
	            <br><br>
	            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
	              <span class="sr-only">Cargando...</span>
	            </div>
	            <br><br>
	          </div>
	        </div>
	      </div>
	`,
	styles: []
})

export class LoadingComponent implements OnInit {


	@Input() seccion:any = '';

	ngOnInit(): void {
		// console.log('apploading: ', this.seccion);
	}
}
